<template>
  <Form :model="formItem" :label-width="80">

    <Row>
      <Col span="24">
        <Form-item label="需求名称">
          <Input v-model="formItem.input" placeholder="请输入"></Input>
        </Form-item>
      </Col>
    </Row>

    <Row>
      <Col span="8">
      <Form-item label="来源">
        <Select v-model="formItem.select" placeholder="请选择">
          <Option value="beijing">北京市</Option>
          <Option value="shanghai">上海市</Option>
          <Option value="shenzhen">深圳市</Option>
        </Select>
      </Form-item>
      </Col>
      <Col span="8">
      <Form-item label="等级">
        <Select v-model="formItem.select" placeholder="请选择">
          <Option value="beijing">北京市</Option>
          <Option value="shanghai">上海市</Option>
          <Option value="shenzhen">深圳市</Option>
        </Select>
       </Form-item>
      </Col>
      <Col span="8">
      <Form-item label="期望日期">
        <Date-picker type="date" class="full-width"  placeholder="选择日期" v-model="formItem.date"></Date-picker>
      </Form-item>
      </Col>
    </Row>

    <Row>
      <Col span="24">
      <Form-item label="背景说明">
        <Input type="textarea" :rows="4" v-model="formItem.input" placeholder="请输入"></Input>
      </Form-item>
      </Col>
    </Row>

    <Row>
      <Col span="24">
      <Form-item label="研发答复">
        <Input type="textarea" :rows="4" v-model="formItem.input" placeholder="请输入"></Input>
      </Form-item>
      </Col>
    </Row>
  </Form>
</template>
<script>
  export default {
    data () {
      return {
        formItem: {
          input: '',
          select: '',
          radio: 'male',
          checkbox: [],
          switch: true,
          date: '',
          time: '',
          slider: [20, 50],
          textarea: ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Add.vue?4cf5c962